import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/modules/pagination/pagination.min.css";
import { Pagination, Keyboard, Autoplay } from "swiper";
import { Card, Image } from "react-bootstrap";
import { Avatar } from "antd";
import { useSelector } from "react-redux";
import ReviewModal from "../../ReviewModal/ReviewModal";

const ReviewSlider = () => {
  const [selected, setSelected] = useState("");
  const [reviews, setReviews] = useState([]);
  const [review, setReview] = useState(null);

  const swiperRef = useRef(null);

  const userSliceState = useSelector((state) => state["userSlice"]);

  useEffect(() => {
    if (review) {
      setSelected(true);
      swiperRef.current.swiper.autoplay.stop();
    } else swiperRef.current.swiper.autoplay.start();
  }, [review]);

  useEffect(() => {
    setReviews(userSliceState.reviews);
  }, [userSliceState.reviews]);

  // Function to generate initials from name
  const generateInitials = (name) => {
    const names = name.split(" ");
    let initials = "";
    if (names.length > 0) {
      initials += names[0].charAt(0);
      if (names.length > 1) {
        initials += names[names.length - 1].charAt(0);
      }
      // else
      //     initials += names[0].charAt(names[0].length - 1)
    }
    return initials.toUpperCase();
  };

  const generateRandomColor = () => {
    const colors = ["#964B00", "#39918C", "#D0B49F", "#AB6B51", "#2F435A"]; // Add more primary colors if needed
    const randomIndex = Math.floor(Math.random() * colors.length);
    return colors[randomIndex];
  };

  const truncateText = (text, limit) => {
    if (text.length <= limit) {
      return text;
    }

    const truncatedText = text.substr(0, limit);
    const lastSpaceIndex = truncatedText.lastIndexOf(" ");
    const finalText = truncatedText.substr(0, lastSpaceIndex) + "...";

    return finalText;
  };

  return (
    <Swiper
      ref={swiperRef}
      initialSlide={2}
      slidesPerView={1}
      spaceBetween={5}
      loop={true}
      keyboard={{
        enabled: true,
      }}
      pagination={{
        clickable: true,
      }}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }}
      modules={[Keyboard, Autoplay, Pagination]}
      breakpoints={{
        450: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 5,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1920: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
        3000: {
          slidesPerView: 3,
          spaceBetween: 120,
        },
      }}
      className="mySwiper pb-4 px-3 w_60 w-xs-100 d-flex justify-content-center align-items-center"
    >
      {reviews && reviews.length
        ? reviews?.map((review) => (
            <SwiperSlide
              key={review.id}
              className="d-flex justify-content-center align-items-center"
            >
              <Card
                onClick={() => {
                  setReview(review);
                }}
                className=" my-4 reviewCard"
              >
                <Card.Body>
                  <div className="text-center productSansBold text_16 border-bottom mx-5">
                    <Avatar
                      className="p-0 size_44x44 text_19 mx-auto d-flex align-items-center my-1 mb-3"
                      style={{
                        background: generateRandomColor(), // Replace "your-color" with the desired background color
                      }}
                      alt={review.name}
                      src={review.img}
                    >
                      {review.img ? (
                        <Image src={review.img} alt={review.name} />
                      ) : (
                        generateInitials(review.name)
                      )}
                    </Avatar>
                    <h5>{review.name}</h5>
                  </div>
                  <Card.Text className="m-4 my-1 text_16 text-center productSansLight">
                    {truncateText(review.description, 192)}
                  </Card.Text>
                </Card.Body>
              </Card>
            </SwiperSlide>
          ))
        : null}
      {selected && (
        <ReviewModal
          review={review}
          setReview={setReview}
          open={selected}
          setOpen={setSelected}
        />
      )}
    </Swiper>
  );
};

export default ReviewSlider;
